import React, { useContext, useState, useEffect } from 'react';
import Header from '../components/Header';
import { InputContext } from '../components/InputContext';
import RecipeList from '../components/RecipeList';
import ProfileImageUpload from '../components/ProfileImageUpload';
import Bio from '../components/Bio';
import './Profile.css';

const baseURL = process.env.REACT_APP_API_URL;


const ProfilePage = () => {
    const { username } = useContext(InputContext);
    const [recipes, setCreatedRecipes] = useState([]);
    const [savedRecipes, setSavedRecipes] = useState([]);

    useEffect(() => {
        if (!username) return;

        const fetchCreatedRecipes = async () => {
            try {
                const response = await fetch(`${baseURL}/recipes/recipes-by-user/${username}`);
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const data = await response.json();
                setCreatedRecipes(data);
            } catch (err) {
                console.error('Error fetching user recipes:', err);
            }
        };

        const fetchSavedRecipes = async () => {
            try {
                const response = await fetch(`${baseURL}/recipes/saved-recipes/${username}`);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                } 

                const data = await response.json();
                console.log('Fetched saved recipes from backend:', data);
                setSavedRecipes(data);
            } catch (err) {
              console.error('Error fetching saved recipes:', err);
            }
        };

        fetchCreatedRecipes();
        fetchSavedRecipes();
    }, [username]);

    return (
        <div className="profile-page">
            <Header />
            <div className="profile-heading">
                <div className="left-side">
                    <ProfileImageUpload />
                    <h2>{username}'s Profile</h2>
                </div>
                <div className="bio-box"><Bio username={username} canEdit={true} /></div>
            </div>

            <div style={{ marginLeft: '70px', marginBottom: '20px' }}>
                <h2>My Recipes</h2>
            </div>
            <RecipeList recipes={recipes} setRecipes={setCreatedRecipes} canEdit={true} />

            <div style={{ marginLeft: '70px', marginBottom: '20px' }}>
                <h2>Saved Recipes</h2>
            </div>
            <RecipeList recipes={savedRecipes} setRecipes={setSavedRecipes} canEdit={true} />
        </div>
    );
}

export default ProfilePage;